/** The Y is two rails joining into one, with gold scene ticks. The rest of the name is text. */
export function YarnLogo() {
  return (
    <span className="yarn-logo" role="img" aria-label="Yarn">
      <svg className="yarn-logo__y" viewBox="0 0 100 116" aria-hidden="true">
        <path
          d="M14 12C14 44 50 44 50 76M86 12C86 44 50 44 50 76V106"
          fill="none"
          stroke="currentColor"
          strokeWidth="13"
          strokeLinecap="round"
        />
        <path
          d="M4 18H24M76 18H96M40 92H60"
          stroke="#f5d76e"
          strokeWidth="6"
          strokeLinecap="round"
        />
      </svg>
      <span aria-hidden="true">arn</span>
    </span>
  );
}
